import { render } from "./OrganisationName.vue?vue&type=template&id=4c301d91&scoped=true"
const script = {}

import "./OrganisationName.vue?vue&type=style&index=0&id=4c301d91&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c301d91"]])

export default __exports__